import * as tslib_1 from "tslib";
import { take } from 'rxjs/operators';
import { OmniGeralRestService } from './../../omni-rest/omni-geral/omni-geral-rest.service';
export class PromotorService {
    constructor(_restService) {
        this._restService = _restService;
        this.liberaCessao = undefined;
    }
    getOperador(idPromotor) {
        return this._restService.get(`operadores/id/${idPromotor}`);
    }
    getOperadorLiberaCessao(idPromotor) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOperador(idPromotor).pipe(take(1)).toPromise();
            this.liberaCessao = response.operador.liberaCessao;
        });
    }
    get isOperadorLiberaCessao() {
        return this.liberaCessao;
    }
    clear() {
        this.liberaCessao = undefined;
    }
}
